import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './breadcrumbs.styles';
import capitalizeString from '@stencil/flights-utils/src/capitalize-string';

const BreadCrumbs = ({ breadcrumb = [], isDweb = false, isCityCountry = false }) => {
  if (!breadcrumb.length) {
    return null;
  }
  return (
    <C.Wrap isDweb={isDweb}>
      <S.BreadCrumbs isCityCountry={isCityCountry}>
        {breadcrumb.map((crumb, index) => {
          if (index === breadcrumb.length - 1) {
            return crumb && crumb.title;
          }
          return (
            <a href={crumb.url} key={`breadcrumb${index}`}>
              <span>{crumb.title} →&nbsp;</span>
            </a>
          );
        })}
      </S.BreadCrumbs>
    </C.Wrap>
  );
};

export default BreadCrumbs;
